import Line from "./v-chart-line.vue";

Line.install = function install(Vue) {
  Vue.component(Line.name, Line);
};

export default Line;
